import { render, staticRenderFns } from "./Benchmarks.vue?vue&type=template&id=03470a70&scoped=true&"
import script from "./Benchmarks.vue?vue&type=script&lang=js&"
export * from "./Benchmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03470a70",
  null
  
)

export default component.exports